// src/i18n/translations.js
export const defaultTranslations = {
  category_labels: {
    category_labels: {
      en: "Category Labels",
    },
    language_handling: { en: "Language Handling" },
    app: { en: "App UI" },
    general: { en: "General" },
    actions: { en: "Actions" },
    riva: { en: "Domain-specific Terms" },
    bpa: { en: "Business Process Architecture" },
    RAD: { en: "Role Activity Diagram" },
    model: { en: "Model" },
    labels: { en: "Labels" },
  },
  language_handling: {
    language: {
      en: "English",
    },
    select_language: {
      en: "Select language",
    },
    lang_curated: {
      en: "Curated",
    },
    lang_standard: {
      en: "Standard ISO",
    },
    lang_custom: {
      en: "Custom",
    },
    lang_fictional: {
      en: "Fictional",
    },
  },
  model: {
    model_name: {
      en: "Name",
    },
    model_name_note: {
      en: "Enter a name for this model",
    },
    model_purpose: {
      en: "Purpose",
    },
    purpose_note: {
      en: "Explain the purpose of this model",
    },
    model_description: {
      en: "Description",
    },
    model_viewpoint: {
      en: "Viewpoint",
    },
    model_changed: {
      en: "Pending changes",
    },
  },
  app: {
    app_title: {
      en: "RIVA Business Process Management",
    },
    home: {
      en: "Home",
    },
    architecture: {
      en: "Architecture",
    },
    theme: {
      en: "Theme",
    },
    settings: {
      en: "Settings",
    },
    help: {
      en: "Help",
    },
    translation_editor: {
      en: "Translation Editor",
    },
    translation_notice: {
      en: "This page is currently available in English only. You can use your browsers translate feature.",
    },
    examples: {
      en: "Examples",
    },
    editorprefs: {
      en: "Editor Preferences",
    },
    custom_color: {
      en: "Custom Color",
    },
  },
  RAD: {
    role: {
      en: "Role",
    },
    thread: {
      en: "Thread",
    },
    state: {
      en: "State",
    },
    interaction: {
      en: "Interaction",
    },
    action: {
      en: "Action",
    },
    trigger: {
      en: "Trigger",
    },
    startrole: {
      en: "Start Role",
    },
    caserefine: {
      en: "Case Refinement",
    },
    partrefine: {
      en: "Part Refinement",
    },
    partrepeat: {
      en: "Part Repeat",
    },
    spring: {
      en: "Spring",
    },
    connection: {
      en: "Connection",
    },
    initiator: {
      en: "Initiator",
    },
  },
  bpa: {
    arch: {
      en: "Process Architecture",
    },
    ebes: {
      en: "Business Entities",
    },
    gen: {
      en: "Process Generation",
    },
    uow: {
      en: "Unit of Work",
    },
    uow_note: {
      en: "Units of Work and their relationships",
    },
    first_cut: {
      en: "First Cut",
    },
    second_cut: {
      en: "Second Cut",
    },
  },
  riva: {
    project: {
      en: "Model",
    },
    editor: {
      en: "Editor",
    },
  },
  labels: {
    name: {
      en: "Name",
    },
    description: {
      en: "Description",
    },
    type: {
      en: "Type",
    },
    status: {
      en: "Status",
    },
    purpose: {
      en: "Purpose",
    },
    version: {
      en: "Version",
    },
    date_created: {
      en: "Date Created",
    },
    date_modified: {
      en: "Date Modified",
    },
  },
  actions: {
    open: {
      en: "Open",
    },
    close: {
      en: "Close",
    },
    edit: {
      en: "Edit",
    },
    new: {
      en: "New",
    },
    save: {
      en: "Save",
    },
    load: {
      en: "Load",
    },
    cancel: {
      en: "Cancel",
    },
    clear: {
      en: "Clear",
    },
    delete: {
      en: "Delete",
    },
    remove: {
      en: "Remove",
    },
    add: {
      en: "Add",
    },
    undo: {
      en: "Undo",
    },
    redo: {
      en: "Redo",
    },
    undo_all: {
      en: "Undo All",
    },
    redo_all: {
      en: "Redo All",
    },
    clear_history: {
      en: "Clear History",
    },
    select: {
      en: "Select",
    },
    export: {
      en: "Export",
    },
    import: {
      en: "Import",
    },
    reset: {
      en: "Reset",
    },
    zoom_in: {
      en: "Zoom In",
    },
    zoom_out: {
      en: "Zoom Out",
    },
    zoom_reset: {
      en: "Zoom Reset",
    },
    zoom_max: {
      en: "Zoom Max",
    },
    zoom_min: {
      en: "Zoom Min",
    },
    zoom_to_fit: {
      en: "Zoom to Fit",
    },
    show_print_modal: {
      en: "Show Print Screen",
    },
    show_fullscreen: {
      en: "Show Full Screen",
    },
    exit_fullscreen: {
      en: "Exit Full Screen",
    },
    print: {
      en: "Print",
    },
  },

  // Add more as needed
};
